import { useMutation, useQueryClient } from "@tanstack/react-query";
import { onboardingApi } from "./api";
import { qk } from "../../lib/queryKeys";

export const useSubmitOnboardingResponses = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: onboardingApi.submitResponses,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
      await qc.invalidateQueries({ queryKey: ["onboarding"] });
    },
  });
};
